import anchorScroll from "./anchorScroll";
export default new (class {
    constructor() {
        this.handler();
        this.iCurrentQuestion = 0;
        this.selectors = {
            form: '#quiz-form'
        };
        // this.$currentNav = document.querySelector('.questions-nav [data-current]');
        // this.$nextNav = document.querySelector('.questions-nav .button_next');
        // this.$prevNav = document.querySelector('.questions-nav .button_prev');

        // this.skipQuestions = new Set();
        // this.mainAnswers = new Set();
        // this.firstScenario = [1, 4, 6, 10];
        // this.thirdScenario = [17, 18];
        // this.value = JSON.parse(this.$form.dataset.value);
        // this.completed = this.value?.completed || 0;
        // this.iResult = 0;
    }

    handler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        this.$form = document.getElementById('quiz-form');
        if (!this.$form) return
        
        this.$currentQuestion = this.$form.querySelector(`[data-question="${this.iCurrentQuestion}"]`);
        this.$sum = this.$form.querySelector('._sum');
        this.$currentNav = document.querySelector('.questions-nav [data-current]');

        this.$form.addEventListener('click', (e) => this.onClick(e));
        this.$form.addEventListener('change', (e) => this.onChange(e));

        // if (this.value) {
        //     const answers = this.value.questions[12].answers.split(',');
        //     answers.forEach(i => this.mainAnswers.add(+i));
        // }
        

        // if (this.completed) {
        //     this.showResults();
        // } else {
        //     //
        //     if (this.value) {
        //         this.goToLastInvalid();
        //     } else {
        //         document.querySelector('[data-first-screen]').classList.remove('hidden');
        //     }
        // }
    }

    onClick(e) {
        if (e.target.closest('.button_start')) {
            this.onStart();
        }

        if (e.target.closest('.button_next')) {
            this.goNext()
        }

        if (e.target.closest('.button_prev')) {
            this.goBack();
        }
    }

    onStart() {
        document.querySelector('.questions-nav').classList.remove('invisible');
        document.querySelector('[data-first-screen]').classList.add('hidden');
        document.querySelector('[data-question="1"]').classList.remove('hidden');
        this.iCurrentQuestion = 1;
        this.$currentQuestion = document.querySelector(`[data-question="${this.iCurrentQuestion}"]`);
    }

    goToLastInvalid() {
        for (let i = 1; i <= 20; i++) {
            const answers = this.value.questions[i-1].answers;
            if (answers) {
                answers.split(',').forEach(answer => {
                    const input = this.$form.elements[`question-${i}-${answer}`];
                    input.checked = true;
                    input?.closest('.label-wrap').classList.remove('label-wrap_checked')
                })
            }
            const otherText =this.$form.elements[`question-${i}-other_text`]
            if (otherText) {
                otherText.value = this.value.questions[i-1].other_text;
            }
        }
        this.checkRules();
        let lastinValid = this.getLastInvalid() || 20;

        document.querySelector('.questions-nav').classList.remove('invisible');
        document.querySelector('[data-first-screen]').classList.add('hidden');
        const question = document.querySelector(`[data-question="${lastinValid}"]`)
        question.classList.remove('hidden');
        this.iCurrentQuestion = lastinValid;
        this.$currentQuestion = question;
        this.validateCurrentQuestion();
        // this.$currentNav.textContent = this.iCurrentQuestion;
        // anchorScroll.scrollTo(this.$currentQuestion);


    }

    getLastInvalid() {
        let lastinValid = 0;
        this.value.questions.forEach((question, i) => {
            if (!lastinValid && !this.skipQuestions.has(i + 1)) {
                if (!question.answers) {
                    if (!(i == 2 && question.other_text)) {
                        lastinValid = i + 1;
                    }
                }
            }
        });
        return lastinValid;
    }

    onChange(e) {
        if (e.target.name == 'policy') {
            document.querySelector('.button_start').disabled = !e.target.checked;
        }
        const questionWrap = e.target.closest('[data-question]');
        if (!questionWrap) return;

        const types = ['checkbox', 'radio']
        if (types.includes(e.target.type)) {
            this.onChangeCheckboxes(e);
            // this.checkRules();
            this.validateCurrentQuestion()
        }
        if (this.$sum) {
            const sum = [...this.$form.querySelectorAll('[data-points]:checked')].reduce((sum,input) => {
                sum += +input.dataset.points;
                return sum;
            }, 0);
            console.log(sum);
            this.$sum.textContent = sum;
        }
    }

    onChangeCheckboxes(e) {
        this.markOrUnmarkCheckbox(e.target);
        // if (this.iCurrentQuestion == 13) {
        //     this.onChangeMainQuestion(e);
        // }

    }

    markOrUnmarkCheckbox(input) {
        if (input.checked) {
            if (input.type == 'radio') {
                this.$currentQuestion.querySelectorAll(`[name="${input.name}"]`).forEach(item => {
                    item.closest('.label-wrap').classList.remove('label-wrap_checked')
                })

                const correct = this.$currentQuestion.querySelector('[data-is-right="1"]');
                if (correct === input) {
                    input.closest('.label-wrap').classList.add('label-wrap_correct');
                } else if (correct) {
                    input.closest('.label-wrap').classList.add('label-wrap_wrong');
                    
                    if (this.$currentQuestion.querySelector('.question-comment')) {
                        this.$currentQuestion.querySelector('.question-content').classList.add('question-content_wrong');
                    }
                }

                this.$currentQuestion.querySelectorAll('input').forEach(input => this.markDisabled(input));
            }

            input.closest('.label-wrap').classList.add('label-wrap_checked');
        } else {
            input.closest('.label-wrap').classList.remove('label-wrap_checked', 'label-wrap_correct', 'label-wrap_wrong')
            this.$currentQuestion.querySelector('.question-content').classList.remove('question-content_wrong')
        }
    }

    markDisabled(input) {
        input.closest('.label-wrap').classList.add('label-wrap_disabled');
        input.disabled = true;
    }

    unmarkDisabled(input) {
        input.closest('.label-wrap').classList.remove('label-wrap_disabled');
        input.disabled = false;
    }

    onChangeMainQuestion(e) {
        const allCheckboxes = Array.from(this.$currentQuestion.querySelectorAll(`[name="${e.target.name}"]`));
        const firstGroup = allCheckboxes.slice(0,16);
        const secondGroup = allCheckboxes.slice(16);


        if (e.target.checked) {
            this.mainAnswers.add(+e.target.value)
            if (firstGroup.includes(e.target)) {
                secondGroup.forEach(item => {
                    item.checked = false;
                    this.markOrUnmarkCheckbox(item);
                })
            } else {
                firstGroup.forEach(item => {
                    item.checked = false;
                    this.markOrUnmarkCheckbox(item);
                })
            }
        } else {
            this.mainAnswers.delete(+e.target.value)
        }
    }

    isValid(questionWrap) {
        // if (this.skipQuestions.has(+questionWrap.dataset.question)) return true;
        if (questionWrap.querySelector(':checked') ) {
            return true;
        } else {
            // if (questionWrap.dataset.question == '3' && questionWrap.querySelector('#question-3-other_text').value) {
            //     return true
            // }
            return false;
        }
    }

    validateCurrentQuestion() {
        if (this.isValid(this.$currentQuestion)) {

            this.$currentQuestion.querySelector('.question-content .button_next').disabled = false;
            // if (this.$currentQuestion.nextElementSibling?.hasAttribute('data-question')) {
            //     this.$nextNav.disabled = false;
            // } else {
            //     this.$nextNav.disabled = true;
            // }
            // this.$nextNav.disabled = false;
        } else {
            this.$currentQuestion.querySelector('.question-content .button_next').disabled = true;
            // this.$nextNav.disabled = true;
        }

        // if (this.$currentQuestion.previousElementSibling?.hasAttribute('data-question')) {
        //     this.$prevNav.disabled = false;
        // } else {
        //     this.$prevNav.disabled = true;
        // }

        // document.querySelector('.progress-bar__inner').style.transform = `translateX(calc(${this.iCurrentQuestion / 20} * 100% - 100%))`
    }

    showInfo(questionWrap) {
        const info =  questionWrap.querySelector('.expert-info');
        info.classList.remove('expert-info_hidden');
        questionWrap.querySelector('.question-content').classList.add('hidden')
    }

    hideInfo(questionWrap) {
        const info =  questionWrap.querySelector('.expert-info');
        if (info) {
            info.classList.add('expert-info_hidden');
            questionWrap.querySelector('.question-content').classList.remove('hidden')
        }
    }

    goNext() {
        let completed = false;
        const currentQuestion = this.$currentQuestion;

        const nextQuestion = this.getNextQuestion();
        if (nextQuestion) {
            currentQuestion.classList.add('hidden');
            nextQuestion.classList.remove('hidden');
            this.iCurrentQuestion = +nextQuestion.dataset.question;

            // if (this.skipQuestions.has(this.iCurrentQuestion)) {
            //     this.showInfo(nextQuestion);
            // } else {
            //     this.hideInfo(nextQuestion);
            // }


            // this.$currentNav.textContent = this.iCurrentQuestion;
            this.$currentQuestion = nextQuestion;
            // anchorScroll.scrollTo(this.$currentQuestion);

            this.validateCurrentQuestion();
            // this.$prevNav.disabled = false;
        } else {
            completed = true;
            this.showResults();

            // this.$nextNav.disabled = true;
        }

        // this.onSave(completed);
    }

    onSave(completed) {
        const formData = new FormData(this.$form);
        const questions = [];

        for (let i = 1; i <= 20; i++) {
            const question = {
                answers: formData.getAll(`question[${i}][]`).join(),
                other_text: formData.get(`question[${i}][other_text]`)
            };
            questions.push(question);
        }

        const data = {
            questions: JSON.stringify(questions),
            questions: questions,
            completed: completed
        }
        oc.ajax('Questionnaire::onSave', {data})

    }

    getNextQuestion() {
        return this.$form.querySelector(`[data-question="${this.iCurrentQuestion + 1}"]`)
        // if (this.skipQuestions.has(this.iCurrentQuestion + 1)) {
        //     const nextQuestion = document.querySelector(`[data-question="${this.iCurrentQuestion + 1}"]`);
        //     if(nextQuestion && nextQuestion.querySelector('.expert-info')) return nextQuestion;

        // } else {
        //     return this.$currentQuestion?.nextElementSibling.hasAttribute('data-question') ? this.$currentQuestion.nextElementSibling : null
        // }
    }

    goBack() {
        if (!this.skipQuestions.has(this.iCurrentQuestion) && this.$currentQuestion.querySelector('.expert-info:not(.expert-info_hidden)')) {
            this.hideInfo(this.$currentQuestion)
        } else {
            const currentQuestion = this.$currentQuestion;
            const prevQuestion = this.getPrevQuestion();
            if (prevQuestion) {
                currentQuestion.classList.add('hidden');
                prevQuestion.classList.remove('hidden');
                this.iCurrentQuestion = prevQuestion.dataset.question;
    
                if (prevQuestion.querySelector('.expert-info')) {
                    this.showInfo(prevQuestion);
                }
    
                // this.$currentNav.textContent = this.iCurrentQuestion;
                this.$currentQuestion = prevQuestion;
                // anchorScroll.scrollTo(this.$currentQuestion);
    
                this.validateCurrentQuestion();
            } else {
                // this.$prevNav.disabled = true;
            }
        }
    }

    getPrevQuestion() {
        if (this.skipQuestions.has(this.iCurrentQuestion - 1)) {
            const prevQuestion = document.querySelector(`[data-question="${this.iCurrentQuestion - 1}"]`);
            if(prevQuestion && prevQuestion.querySelector('.expert-info')) return prevQuestion;
            
            return document.querySelector(`[data-question="${this.iCurrentQuestion - 2}"]`)
        } else {
            return this.$currentQuestion?.previousElementSibling.hasAttribute('data-question') ? this.$currentQuestion.previousElementSibling : null
        }
    }

    showResults() {
        oc.request(this.$form, 'onGetResult');

        // if (!this.iResult) {
        //     let iResult = 0;
            
        //     this.thirdScenario.forEach(item => {
        //         if (this.mainAnswers.has(item)) iResult = 3;
        //     });

        //     this.firstScenario.forEach(item => {
        //         if (this.mainAnswers.has(item)) iResult = 1;
        //     });

        //     this.iResult = iResult || 2;
        // }
        // document.querySelector('.questions-nav').classList.add('invisible');
        // this.$currentQuestion?.classList.add('hidden')
        // document.querySelector(`[data-result="${this.iResult}"]`).classList.remove('hidden');
        // document.querySelector('[data-last-screen]').classList.remove('hidden')
        // anchorScroll.scrollTo(document.querySelector('[data-last-screen]'))
    }

    checkRules() {
        const formData = new FormData(this.$form);

        if (formData.get(`question[4][]`) != '7') {
            this.skipQuestions.add(6)
            this.skipQuestions.delete(5)
        } else {
            this.skipQuestions.delete(6)
            this.skipQuestions.add(5)
        }


        if (+formData.get(`question[7][]`) > 2) {
            this.skipQuestions.add(8)
        } else {
            this.skipQuestions.delete(8)
        }

        if (+(formData.get(`question[14][]`)??NaN) <= 2) {
            this.skipQuestions.add(15)
        } else {
            this.skipQuestions.delete(15)
        }

        if (+formData.get(`question[18][]`) > 2) {
            this.skipQuestions.add(19)
        } else {
            this.skipQuestions.delete(19)
        }
    }
})();
